import { Assert } from '@team/assert';
import { fromEntries } from './from-entries.js';
import { toEntries } from './to-entries.js';

type CamelToSnakeCaseKey<S extends string> = S extends `${infer T}${infer U}`
  ? U extends Capitalize<U>
    ? `${Lowercase<T>}_${CamelToSnakeCaseKey<U>}`
    : `${Lowercase<T>}${CamelToSnakeCaseKey<U>}`
  : S;

export type CamelToSnakeCase<T> = T extends UnknownObject
  ? {
      [K in keyof T as CamelToSnakeCaseKey<K & string>]: T[K];
    }
  : T;

function camelToSnakeKey(str: string): string {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
}

export function camelToSnakeFlat<T>(input: T): CamelToSnakeCase<T>;
export function camelToSnakeFlat(input: UnknownObject): UnknownObject {
  if (!Assert.isUnknownObject(input)) {
    return input;
  }

  return fromEntries(
    toEntries(input).map(([key, value]) => [camelToSnakeKey(key), value])
  );
}
